export const ITEM_ID_SEIZURE = '5e81db67b1b4e673bc2bb8fb'
export const ITEM_ID_SHORT_SEIZURE = '65493aa09fc26478fc547e04'
export const INCIDENT_CATEGORY_ID = '5e867702b349f776c8d48c34'
export const HR_CATEGORY_ID = '5e867702b349f776c8d48c30'
export const SAFEGUARDING_ITEM_ID = '68cae49a5df0b900121771f2'

export const EMAR_STOCK_SUMMARY_ITEM_ID = 'emarStockSummary'
